<div class="m-15 wrapper" style="position: relative">
  <div
    class="not-pro-message-wrapper"
    *ngIf="
      sharedDataService.data != null &&
      sharedDataService.data.tier != null &&
      sharedDataService.data.tier != 'pro'
    "
  >
    <div class="not-pro-icon">
      <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0)">
          <path
            d="M78.625 37.5H75.5V25C75.5 11.2125 64.2875 0 50.5 0C36.7125 0 25.5 11.2125 25.5 25V37.5H22.375C17.2083 37.5 13 41.7042 13 46.875V90.625C13 95.7958 17.2083 100 22.375 100H78.625C83.7917 100 88 95.7958 88 90.625V46.875C88 41.7042 83.7917 37.5 78.625 37.5ZM33.8333 25C33.8333 15.8083 41.3083 8.33333 50.5 8.33333C59.6917 8.33333 67.1667 15.8083 67.1667 25V37.5H33.8333V25ZM54.6667 69.675V79.1667C54.6667 81.4667 52.8042 83.3333 50.5 83.3333C48.1958 83.3333 46.3333 81.4667 46.3333 79.1667V69.675C43.8542 68.2292 42.1667 65.5708 42.1667 62.5C42.1667 57.9042 45.9042 54.1667 50.5 54.1667C55.0958 54.1667 58.8333 57.9042 58.8333 62.5C58.8333 65.5708 57.1458 68.2292 54.6667 69.675Z"
            fill="#C7700A"
          />
        </g>
      </svg>
    </div>
  </div>

  <div class="filters-wrapper justify-content-between align-items-center px-4">
    <div class="d-flex align-items-center justify-content-between">
      <div class="dropdown-timetracking">
        <span
          dropdown
          [autoClose]="true"
          [insideClick]="true"
          #clientDropdown="bs-dropdown"
          (onShown)="onDropdownShown()"
        >
          <div dropdownToggle>
            <i class="tio-pinned_bys"></i>
            <span class="sort-by">{{
              dashboardService.filters()[dashboardName]?.clientFilter.label
            }}</span>
            <i class="feather chevron-down"></i>
          </div>
          <ul
            *dropdownMenu
            class="dropdown-menu p-relative"
            aria-labelledby="dLabel"
            role="menu"
          >
            <li style="top: -9px; position: sticky; background: #fff">
              <div class="py-2 position-relative">
                <input
                  #searchInput
                  type="text"
                  class="form-control"
                  placeholder="Search clients"
                  [(ngModel)]="filterText"
                  (ngModelChange)="filterClients()"
                />
                <i
                  [hidden]="!filterText.length"
                  class="tio-clear"
                  style="
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    cursor: pointer;
                    opacity: 0.5;
                    font-size: 20px;
                  "
                  (click)="clearSearch()"
                >
                </i>
              </div>
            </li>
            <li
              (click)="changeClientFilter('all'); clientDropdown.hide()"
              role="menuitem"
            >
              <a>All clients</a>
            </li>

            <li class="divider dropdown-divider"></li>

            @for (
              client of filteredClients | activeClientsOnly;
              track client.uuid
            ) {
              <li role="menuitem">
                <a
                  (click)="
                    changeClientFilter(client?.uuid, client?.name);
                    clientDropdown.hide()
                  "
                  class="dropdown-item"
                  >{{ client?.name }}</a
                >
              </li>
            }
          </ul>
        </span>
      </div>

      <div class="dropdown-timetracking">
        <span dropdown [autoClose]="true">
          <div dropdownToggle>
            <i class="tio-pinned_bys"></i>
            <span class="sort-by">{{
              dashboardService.filters()[dashboardName]?.statusFilter.label
            }}</span>
            <i class="feather chevron-down"></i>
          </div>
          <ul
            *dropdownMenu
            class="dropdown-menu"
            aria-labelledby="dLabel"
            role="menu"
          >
            <li role="menuitem">
              <a (click)="changeStatusFilter('open')" class="dropdown-item"
                >Open</a
              >
            </li>
            <li role="menuitem">
              <a (click)="changeStatusFilter('answered')" class="dropdown-item"
                >Answered</a
              >
            </li>
          </ul>
        </span>
      </div>

      <div
        class="dropdown-timetracking"
        *ngIf="
          dashboardService.filters()[dashboardName]?.statusFilter.value == 'open'
        "
      >
        <span dropdown #dropdown="bs-dropdown">
          <div dropdownToggle>
            <i class="feather calendar"></i>
            <span class="sort-by">{{
              dashboardService.filters()[dashboardName]?.timeFrameFilter.label
            }}</span>
            <i class="feather chevron-down"></i>
          </div>
          <ul
            style="min-width: 280px"
            *dropdownMenu
            class="dropdown-menu"
            aria-labelledby="dLabel"
            role="menu"
          >
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="changeTimeframeFilter('all'); dropdown.hide()"
                >All</a
              >
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="changeTimeframeFilter('over'); dropdown.hide()"
                >Over 7 Days</a
              >
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="changeTimeframeFilter('between'); dropdown.hide()"
                >2 to 7 Days</a
              >
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="changeTimeframeFilter('close'); dropdown.hide()"
                >Less than 2 Days</a
              >
            </li>
            <!-- <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="changeTimeframeFilter(null); dropdown.hide()"
                >All</a
              >
            </li> -->
          </ul>
        </span>
      </div>

      <div class="dropdown-timetracking">
        <ng-template #workspaceFilterIcon>
          <div style="display: inline-block; cursor: pointer;">Client Tag</div>
          <div
            style="display: inline-block; margin-left: 8px; cursor: pointer;"
            class="tag-add"
            tooltip="Filter by tags"
          >
            @if (workspace_tags_filter.length == 0) {
              <i class="tio-filter_outlined" style="opacity: 0.6"></i>
            }
            @if (workspace_tags_filter.length > 0) {
              <i class="tio-filter filter-filled"></i>
            }
          </div>
        </ng-template>

        <ng-template #workspaceExtension>
          @if (workspace_tags_filter.length > 0) {
            <h4 style="font-size: 20px">Selected tags:</h4>
          }
          @if (workspace_tags_filter.length > 0) {
            <p style="font-size: 14px">
              Show items with
              <b>{{
                andOrWorkspaces == "and"
                  ? "all"
                  : andOrWorkspaces == "or"
                    ? "any"
                    : "none"
              }}</b>
              of these tags:
            </p>
          }
          @for (tag of workspace_tags_filter; track tag.uuid) {
            <ch-tag
              [name]="tag.name"
              [color]="tag.color"
              (click)="removeTagFromFilter(tag, 'workspace')"
            ></ch-tag>
          }
          @if (workspace_tags_filter.length > 0) {
            <div>
              <hr />
              <button class="btn btn-default" (click)="clearFilter('workspace')">
                Clear
              </button>
            </div>
          }
        </ng-template>

        <ch-tag-add
          #workspaceFilterTagList
          [existingTags]="workspace_tags_filter"
          [removeTagOnClick]="true"
          (tagClick)="addTagToFilter($event)"
          [extension]="workspaceExtension"
          [icon]="workspaceFilterIcon"
          (andOrFilterChanged)="retrieveTrackedItems($event)"
        ></ch-tag-add>
      </div>
    </div>

    <div
      class="btn-group export-button"
      dropdown
      [autoClose]="true"
      placement="bottom right"
    >
      <button
        id="button-basic"
        dropdownToggle
        type="button"
        class="btn btn-success dropdown-toggle"
        aria-controls="dropdown-basic"
      >
        Export <span class="caret"></span>
      </button>
      <ul
        id="dropdown-basic"
        *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        role="menu"
        aria-labelledby="button-basic"
        style="z-index: 999999"
      >
        <li (click)="exportExcel()" class="p-button-success mr-2">
          <a class="dropdown-item">
            <i class="feather table"></i>
            Export to .xls</a
          >
        </li>
        <li (click)="exportPdf()" class="p-button-warning mr-2">
          <a class="dropdown-item">
            <i class="feather table"></i>
            Export to .pdf</a
          >
        </li>
        <li (click)="exportCsv()" class="p-button-warning mr-2">
          <a class="dropdown-item">
            <i class="feather table"></i>
            Export to .csv</a
          >
        </li>
      </ul>
    </div>
  </div>

  <p-table
    [value]="tracked_items"
    [rowHover]="true"
    #table
    sortMode="single"
    [scrollable]="true"
    [rows]="dashboardService.filters()[this.dashboardName].rows || 25"
    (onPage)="onPageChange($event)"
    [lazy]="true"
    [totalRecords]="totalRecords"
    (onLazyLoad)="retrieveTrackedItems($event)"
    [paginator]="true"
    [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
    [loading]="loading"
    scrollHeight="calc(100vh - 245px)"
    styleClass="job-list"
    responsiveLayout="scroll"
    [resizableColumns]="true"
    columnResizeMode="fit"
    rowGroupMode="subheader"
    groupRowsBy="company"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  >
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="4">
          <div class="empty-dashboard-row-content">
            <ds-empty-state
              icon="tio-checkmark_circle"
              title="No Client Tasks to Display"
              description="Start by client tasks or check back later to see updates."
            ></ds-empty-state>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 200px">Client</th>
        <th style="min-width: 200px">Created By</th>
        <th style="min-width: 200px">Created Date</th>
        <th style="min-width: 200px">Task Card</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="groupheader" let-tracked_item>
      <tr style="background: #dee2e6 !important">
        <td colspan="1000" style="padding: 1px"></td>
      </tr>
      <tr
        pRowGroupHeader
        class="border-top-table-separator"
        style="top: 23px !important; background: #fff !important"
      >
        <td colspan="1000">
          <span class="font-bold ml-2">
            {{ getClientCompanyName(tracked_item.company).name }}
          </span>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-tracked_item let-rowIndex="rowIndex">
      <tr>
        <td></td>
        <td>
          <img
            class="avatar avatar24"
            [alt]=""
            [src]="tracked_item.created_by.pictureUrl"
            style="
              vertical-align: middle;
              margin-right: 8px;
              width: 24px;
              height: 24px;
            "
          />
          <span class="font-bold ml-2">
            {{ tracked_item.created_by.full_name }}
          </span>
        </td>
        <td>{{ tracked_item.date | amDateFormat: "MMM Do, YYYY" }}</td>
        <td>
          <tracked-item-bubble
            [tracked_item]="tracked_item"
            [company]="getClientCompanyName(tracked_item.company)"
            [user]="sharedDataService.user"
            [canAnswer]="false"
            [shouldOpenDrawer]="true"
          >
          </tracked-item-bubble>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
